
export const getLocale = () => document.getElementsByTagName('html')[0].getAttribute('lang');
